import styled from 'styled-components';

const VideoStyle = styled.div`
	--videoPadTop: 50%;

	--playPauseButtonSize: var(--sp15x);

	&.video-cont {
		position: relative;
		width: 100%;
		padding-top: var(--videoPadTop);

		video {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			object-fit: cover;
			object-position: center;
			z-index: 1;
		}

		.video-icon {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			font-size: var(--playPauseButtonSize);
			color: var(--white1000);
			z-index: 7;
			cursor: pointer;
		}

		.play-pause-block {
			display: flex;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 7;
			opacity: 0;
			transition: opacity var(--trTime) linear;
			cursor: pointer;

			.lottie-wrap {
				display: flex;
			}

			svg {
				width: var(--playPauseButtonSize) !important;
				height: var(--playPauseButtonSize) !important;
			}

			&.active {
				opacity: 1;
				transition-delay: 0;
			}
		}
	}

	//! 1920
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--playPauseButtonSize: var(--sp11x);
	}

	//! 1536
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--playPauseButtonSize: var(--sp9x);
	}

	//! 1366
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--playPauseButtonSize: var(--sp7x);
	}

	//! 1280
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--playPauseButtonSize: var(--sp7x);
	}

	//! 1024
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--playPauseButtonSize: var(--sp7x);
	}

	//! 768
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--playPauseButtonSize: var(--sp6x);
	}

	//! Mobile
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--playPauseButtonSize: var(--sp6x);
	}
`;

export default VideoStyle;
